// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4c1bc8ba","453":"e9be5dae"}[chunkId] + ".chunk.js";
};